<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { websocketPush } from "@/utils/api.js";
let isOPen = false;
export default {
  name: "App",
  components: {},
  created() {},
  mounted() {
    this.websocketPush();
  },
  methods: {
    websocketPush() {
      var _this = this;
      let data = {
        WEBSOCKET_VISIT_URL: "WEBSOCKET_VISIT_URL",
      };
      console.log("url", data);
      websocketPush(data).then((res) => {
        console.log(res);
        if (res.code == 200) {
          let webUrl = res.ret.paramValue;
          if (this.websocket) {
            this.websocket.close();
          }
          initWebsocket();
          _this.websocket.onmessage = (e) => {
            if (e.data) {
              let webData = JSON.parse(e.data);
              // console.log(webData, "11111", webData.msgType, "***");

              if (webData.msgType == 1) {
                // console.log('webData.data', webData.data)
                // _this.webSocketContractPrice(webData.data)
                _this.$store.dispatch("setMatchPrice", webData.data);
              }
            }
          };
          _this.websocket.onopen = (e) => {
            isOPen = true;
            if (_this.websocket) {
              _this.websocket.send(
                JSON.stringify({
                  type: 0,
                })
              );
            }
          };
          _this.websocket.onerror = (e) => {
            initWebsocket();
          };

          function initWebsocket() {
            const wsuri = `wss://${webUrl}/websocket/futures/websocket`;
            _this.websocket = new WebSocket(wsuri);
          }
        }
      });
    },
  },
};
</script>
<style>
#app {
  width: 100%;
  overflow: hidden;
}
img {
  /* width: 100%; */
  /* height: auto; */
}
.line-clamp1 {
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
}
.line-clamp2 {
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2; /*要显示的行数*/
  -webkit-box-orient: vertical;
}
.flex-space-between {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/App.vue